export default __webpack_public_path__ + "543b195651691257db411eadc9704bcc.png";